export const suggestionItemTestIdPrefix = 'search-suggestion-item-';
